module.exports = __webpack_public_path__ + "static/img/szsw_logo.9960edfb.png";